interface LeftLabelProps {
  label: string;
  info?: React.ReactNode | null;
  children?: React.ReactNode;
}

export default function LeftLabel({ label, info, children }: LeftLabelProps) {
  return (
    <div className="flex items-center gap-3">
      <p className="w-[80px] whitespace-nowrap text-sm font-bold">{label}</p>
      {children ? (
        children
      ) : (
        <p className="line-clamp-1 overflow-hidden text-ellipsis text-zinc-700">
          {info || "-"}
        </p>
      )}
    </div>
  );
}
